import React from 'react';
import styled from 'styled-components';

const StyledTextSegment = styled.text`{
    resize: none;
    display: flex;
    flex-direction: row; 
    align-items: center;
    justify-items: center;
    background-color: #EFF0F0; 
    border-radius: 10px; 
    overflow: hidden;
    width: 100%;
    padding-right: 64px;
    padding-top: 8px;
    padding-bottom: 16px;
    border-color: transparent;
    min-height: 60px;
    overflow-y: auto;
    word-wrap:break-word
  }`
  
  const StyledTextArea = styled.div` {
    resize: none;
    display: flex;
    flex-direction: column; 
    align-items: left;
    justify-content: left;
    background-color: #EFF0F0; 
    border-radius: 10px; 
    overflow: hidden;
    padding-top: 32px;
    padding-bottom: 64px;
    width: 75%;
    margin: 0 auto;
    margin-bottom: 128px;
    margin-top: 64px;
    padding-left: 64px;
    padding-right: 25%;

  }`

  const Avatar = styled.div`
    align-self: flex-start;    
    width: 120px; 
    height: 120px; 
    margin-top: 16px;
    margin-bottom: 32px;
    border-radius: 100px;
    background-image: url(${props => props.img});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
`


const EditButton = styled.button`
    float: right;
    margin-right: 0px;
    display:block;
    align-self: right;
    width: fit-content; 
    padding: 12px 24px; 
    border-radius: 10px; 
    background-color: #377879;
    color: #fff; 
    align-items: right; 
    transition: background 250ms ease-in-out, 
    transform 150ms ease;
    -webkit-appearance: none;
    -moz-appearance: none;
    border-color: none;
    border-style: none;
    border-width: none;
`

const TableLabel = styled.div`
    width: 100%;
    display: flex;
    justify-content: left;
    align-items: left;
`

const TableEdit = styled.div`
    margin-right: 0px;
    display:block;
    height: 32px;
    float: right;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`

const Table = styled.table`
    table-layout: fixed;
    width: 100%;
 
`


export const editProfile = () => (
    <div className ="custom-container">
        <h2 className= 'mt-4'>Your Profile Information</h2>
        <div>
            <StyledTextArea>
                <h2 className= 'mt-4'>Profile Photo</h2>
                <Table>
                    <td><TableLabel><Avatar img= {require('./img/jane_pearson.jpg')}/></TableLabel></td>
                    <td><TableEdit><EditButton>Change</EditButton></TableEdit></td>
                </Table>
                <h2 className= 'mt-4'>Name</h2>
                <Table>
                    <td><TableLabel><StyledTextSegment>Jane Pearson</StyledTextSegment></TableLabel></td>
                    <td><TableEdit><EditButton>Change</EditButton></TableEdit></td>
                </Table>
                <h2 className= 'mt-4'>Email Address</h2>
                <Table>
                    <td><TableLabel><StyledTextSegment>jane.pearson@gmail.com</StyledTextSegment></TableLabel></td>
                    <td><TableEdit><EditButton>Change</EditButton></TableEdit></td>
                </Table>
                <h2 className= 'mt-4'>Phone Number</h2>
                <Table>
                    <td><TableLabel><StyledTextSegment>123-456-7890</StyledTextSegment></TableLabel></td>
                    <td><TableEdit><EditButton>Change</EditButton></TableEdit></td>
                </Table>

            </StyledTextArea>
            </div>
    </div>
)

export default editProfile;